import * as React from 'react';
import { styles } from './styles';
import { DemoSection, DemoSectionProps } from '../components/DemoSection';
import { SelectableOption } from '../../SelectableOption';
import { MoreOptionsMessage } from '../../MoreOptionsMessage';
import { Columns } from '@joykit';
import { SpatialOption } from '@joykit/variables/space';
import { Layout } from '@graphql/types';
import { UseWeddingColorSection } from './components/UseWeddingColorSection';
import { DesignShowcase_designShowcase_organization_colors_buckets } from '@graphql/designShowcaseTypes';
import chroma from 'chroma-js';

const MESSAGE = 'You can mix your own custom colors after getting started with this design.';

const HEX_STRING_MAP = new Map<string, string>();

const renderOptions = (colors: Props['colors'], currentColor: Props['color'], onClick: Props['onColorSelect']) => {
  return (
    <Columns columnGap={SpatialOption.sm} multiline={true} className={styles.container} stackOnMobile={true}>
      {colors.map(color => {
        if (!color.displayRGBAColor) {
          return;
        }

        let hexColor = HEX_STRING_MAP.get(color.displayRGBAColor.hexString);
        if (!hexColor) {
          hexColor = chroma(color.displayRGBAColor.hexString).hex();
          HEX_STRING_MAP.set(color.displayRGBAColor.hexString, hexColor);
        }

        return (
          <Columns.Column key={color.bucketId} mobile="one-quarter" tablet="one-quarter">
            <SelectableOption
              key={color.bucketId}
              section="colors"
              displayString={color.displayString}
              value={hexColor}
              onClick={onClick}
              className={styles.optionContainer}
              ariaLabel={color.displayString}
            >
              <div className={styles.colorOption(hexColor, currentColor === hexColor, false, hexColor === '#ffffff')} />
            </SelectableOption>
          </Columns.Column>
        );
      })}
    </Columns>
  );
};

interface Props extends DemoSectionProps {
  color: string;
  currentLayout: Layout;
  currentThemeKey: string;
  displayString: string;
  useSuggestedBackgroundColor: boolean;
  colors: DesignShowcase_designShowcase_organization_colors_buckets[];
  onColorSelect: React.MouseEventHandler<HTMLElement>;
  onStartClick: React.MouseEventHandler<HTMLButtonElement>;
  onUseWeddingColorClick: React.MouseEventHandler<HTMLElement>;
}

export const ColorDesign: React.SFC<Props> = ({
  open,
  color,
  displayString,
  useSuggestedBackgroundColor,
  colors,
  onColorSelect,
  onSectionToggle,
  onStartClick,
  onUseWeddingColorClick,
  currentThemeKey,
  currentLayout
}) => {
  return (
    <DemoSection
      open={open}
      onSectionToggle={onSectionToggle}
      section="colors"
      name="Change Wedding Color"
      subtitle={
        <div className={styles.selectedColorContainer}>
          <div className={styles.colorOption(color, false, true)} />
          <span>{displayString}</span>
        </div>
      }
    >
      <div className={styles.weddingColorsContainer}>{renderOptions(colors, color, onColorSelect)}</div>
      <UseWeddingColorSection
        useSuggestedBackgroundColor={useSuggestedBackgroundColor}
        currentLayout={currentLayout}
        currentThemeKey={currentThemeKey}
        onUseWeddingColorClick={onUseWeddingColorClick}
      />
      <MoreOptionsMessage id={'color'} message={MESSAGE} onClick={onStartClick} />
    </DemoSection>
  );
};
